export enum ContractNames {
  // Token itself
  StakingToken = "StakingToken",

  // Basic staking and tier manager
  Staking = "Staking",
  StakingTierManager = "StakingTierManager",

  // Time-weighted staking and tier manager
  TWStaking = "TimeWeightedStaking",
  TWStakingTierManager = "StakingTierManagerWeighted",

  // Feeders
  DiscountFeeder = "DiscountFeeder",
  RewardFeeder = "RewardFeeder",

  // Reward vault
  RewardVault = "RewardVault",
  UserBMPurchaser = "UserBMPurchaser",

  // Engagements discount
  EngagementOracle = "EngagementOracle",
  EngagementDiscountTierManager = "EngagementDiscountTierManager",
  TimeFrameOracle = "TimeFrameOracle",
}
